export const AUTH_PAGES = ['/login', '/register', '/retrieve', '/change-password'];